<template>
  <component :is="config.name" v-bind="config.props||{}" class="original-component-wrap"></component>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue';
 


// Define props
const props = defineProps({
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
  idx: {
    type: Number,
    default: -1,
  },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object,
  },
});

// Computed property for currentElementIndexStr
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex && props.currentElementIndex.length
    ? props.currentElementIndex.join('x')
    : '';
});

// Watchers
watch(
  () => props.config.article,
  (value) => {
    if (value) {
   
    }
  },
  { deep: true }
);

watch(
  () => props.config,
  (value) => {
    // Handle config changes here if necessary
  },
  { deep: true, immediate: true }
);
 

// onMounted
onMounted(() => {
  // Handle mounted logic if necessary
});
</script>

<style scoped>
.original-component-wrap {
  /* Add styles if needed */
}
</style>
